import Layout from "@/layout/index";
import Logout from "@/views/Logout.vue";
import LoginTemp from "@/views/LoginTemp.vue";
import Pdf from '@/components/pdf/index.vue'
import Account from "@/views/Platform/Account/index";
import Platform from "@/views/Platform/index";
import Introduce from "@/views/Platform/Introduce/index";
import Process from "@/views/Process.vue";
import Vue from "vue";
import VueRouter from "vue-router";
import beforeEach from "./beforeEach";

//플랫폼
//마이페이지
import Mypage_confirmList from "@/components/platform_new/mypage/confirm.vue"
//프로세스검색 페이지
import PlatformSearch from "@/components/platform_new/newSearch.vue";
import PlatformDetail from "@/components/platform_new/newDetail.vue";
import ProcessRoute from './process' ;
import ExperimentRoute from './experiment' ;
import VisualizationRoute from './visualization' ;
import ProtocolRoute from './protocol' ;

import PDFDowloadRoute from './pdfdownload';
import WorkingScreen from "@/components/etc/workingScreen.vue";
// 문헌 수집 (lit)
import LitRegistry from "@/views/Platform/Literature/LitRegistry.vue";
import LitPaper from "@/views/Platform/Literature/LitPaper.vue";
import LitExplore from "@/views/Platform/Literature/LitExplore.vue";
import LitTokenPanel from "@/views/Platform/Literature/LitTokenPanel.vue";
// 데이터 시각화(데이터 연관관계·지식그래프) — 홈 「시각화」 카드·GNB. 레거시 /visualization/* (게이트·에디터)와는 별개.
import DvHome from "@/views/Platform/DataVisualization/DvHome.vue";
import DvCorrelation from "@/views/Platform/DataVisualization/DvCorrelation.vue";
import DvKnowledgeGraph from "@/views/Platform/DataVisualization/DvKnowledgeGraph.vue";
import DvSearch from "@/views/Platform/DataVisualization/DvSearch.vue";

Vue.use(VueRouter);

// 중복 라우터 푸시 방지 
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push( location : any ) {
	return originalPush.call(this, location).catch(( err : any ) => {
		if (err.name !== 'NavigationDuplicated') throw err;
	});
};

// 중복 라우터 리플레이스 방지 
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace( location : any ) {
	return originalReplace.call(this, location).catch(( err : any ) => {
		if (err.name !== 'NavigationDuplicated') throw err;
	});
};

// 작업중 표시 변수
const workingIng = false ;

const routes = [
  ProcessRoute , 
  ProtocolRoute ,
  ExperimentRoute ,
  PDFDowloadRoute,
  VisualizationRoute ,
  {
    path: "/login",
    component: workingIng ? WorkingScreen : Pdf,
    children: [
      {
        path: "temp", // 플랫폼 마이페이지
        component: LoginTemp,
      },
    ]    
  },
  {
    path: "/account",
    component: workingIng ? WorkingScreen : Layout.Platform,
    children: [
      {
        path: "mypage", // 플랫폼 마이페이지 회원정보
        component: Account.Mypage,
      },
      {
        path: "mypage/createdList", // 플랫폼 마이페이지 작성목록
        component: Account.CreatedList,
      },
      {
        path: "mypage/CreatedDetail", // 플랫폼 마이페이지 작성목록 (상세보기)
        component: Account.CreatedDetail,
      },
      {
        path: "mypage/lit-token", // 마이페이지 문헌 업로드 토큰 (문헌 수집)
        component: LitTokenPanel,
      },
      {
        path: "login", // 플랫폼 로그인
        name: "login",
        component: Account.Login,
      },
      {
        path: "signup", // 플랫폼 회원가입(일반)
        component: Account.Signup,
      },
      {
        path: "find-id", // 플랫폼 회원가입(일반)
        component: Account.FindId,
      },
      {
        path: "find-pw", // 플랫폼 회원가입(일반)
        component: Account.FindPw,
      },
      {
        path: "logout", // 플랫폼 회원가입(일반)
        component: Logout,
      },
      {
        path: "clear-idLock", // 플랫폼 회원가입(일반)
        component: Account.ClearIdLock,
      },
    ],
  },
  // 플랫폼 신규 페이지 경로 및 컴포넌트 테스트
  {
    path: "/platform",
    component: workingIng ? WorkingScreen : Layout.Platform,
    children: [
      {
        path: "",
        // name: "Platform",
        component: Platform.Home,
      }, 
      {
        path: "search",
        component: PlatformSearch
      },
      {
        path: "detail",
        component: PlatformDetail
      },
      {
        path:'/mypage/confirm',
        component: Mypage_confirmList,
      },
      {
        path: "process",
        component: Platform.Process,
      },
      {
        path: "protocol",
        component: Platform.Protocol,
      },
      {
        path: "/wikiPdfDownload",
      }
    ]
  },

  // 플랫폼 - Search, 소개, 공정도, 프로토콜, 마이페이지 등
  {
    path: "/",
    component: workingIng ? WorkingScreen : Layout.Platform,
    children: [
      {
        path: "",
        // name: "Platform",
        component: Platform.Home,
      },
      {
        path: "search",
        component: Platform.Search,
      },
      {
        path: "literature", // 문헌 수집 목록
        component: LitRegistry,
      },
      {
        path: "literature/explore", // 문헌 수집 탐색(검색·시각화)
        component: LitExplore,
      },
      {
        path: "literature/:id", // 문헌 수집 논문 상세
        component: LitPaper,
      },
      {
        path: "data-visualization", // 데이터 시각화 랜딩(데이터 연관관계·지식그래프)
        component: DvHome,
      },
      {
        path: "data-visualization/correlation", // 데이터 시각화 - 데이터 연관관계
        component: DvCorrelation,
      },
      {
        path: "data-visualization/knowledge-graph", // 데이터 시각화 - 지식그래프
        component: DvKnowledgeGraph,
      },
      {
        path: "data-visualization/search", // 데이터 시각화 - 데이터 기반 검색(조건 필터 → 결과 표 → 출력 특성)
        component: DvSearch,
      },
      // 옛 주소 호환(2026-10-05~10-19 사이 /ai 로 배포된 적 있음). /ai 는 AI 카드용으로 비워 둔다. query(series)는 유지됨.
      { path: "ai", redirect: "/data-visualization" },
      { path: "ai/correlation", redirect: "/data-visualization/correlation" },
      { path: "ai/knowledge-graph", redirect: "/data-visualization/knowledge-graph" },
      {
        path: "introduce",
        redirect: "introduce/overview",
      },
      {
        path: "introduce/overview",
        component: Introduce.Overview,
      },
      {
        path: "introduce/necessity",
        component: Introduce.Necessity,
      },
      {
        path: "introduce/strategy",
        component: Introduce.Strategy,
      },
      {
        path: "introduce/member",
        component: Introduce.Member,
      },
      {
        path: "process",
        component: Platform.Process,
      },
      {
        path: "protocol",
        component: Platform.Protocol,
      },
      {
        path: "terms", // 약관
        component: Platform.Terms,
      },
      {
        path: "register-application", // 간사,위원 등록
        component: Platform.RegisterApplication,
      },
    ],
  },
  {
    path: "/*",
    // component: Platform.Home,
    redirect: "/",
  },
  {
    path: "/wikiPdfDownload",
    meta: { requireAuth: true },
  }
];

const router = new VueRouter({
  mode: "history", // electron은 hash모드로 사용해야 함. => electron webview 사용으로 history mode 사용
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (to.params.fixScroll) return savedPosition;
    else return { x: 0, y: 0 };
  },
  routes,
});

router.beforeEach(beforeEach);

export default router;
